import React from 'react';
import { format } from 'date-fns';

import { DayColumn } from './DayColumn';
import { HoverCard } from './HoverCard';
import { CalendarEvent, EventColorSet, EventsByDate } from 'pages/Agenda/utils';
import { useWeekView } from '../../../hooks/useWeekView';
import { getMonthDays } from '../utils/getMonthDays';
import { Grid } from '../styled';

interface MonthViewProps {
  currentDate: Date;
  events: EventsByDate;
  horasPrevistasByDate: Record<string, string>;
  isCompletedView: boolean;
  onCardClick: (event: CalendarEvent, colorSet: EventColorSet) => void;
  onNavigate: (direction: 'prev' | 'next') => void;
}

export const MonthView: React.FC<MonthViewProps> = ({
  currentDate,
  events,
  horasPrevistasByDate,
  isCompletedView,
  onCardClick,
  onNavigate,
}) => {
  const { hoveredCard, setHoveredCard, isDragging, getColorSet } = useWeekView();
  const monthDays = getMonthDays(currentDate);

  return (
    <>
      <Grid>
        {monthDays.map((day, index) => (
          <DayColumn
            key={day.toISOString()}
            date={day}
            dayIndex={index % 7}
            events={events[format(day, 'yyyy-MM-dd')] || []}
            horasPrevistasLabel={horasPrevistasByDate[format(day, 'yyyy-MM-dd')] ?? '00:00h'}
            onCardHover={setHoveredCard}
            onCardLeave={() => setHoveredCard(null)}
            onCardClick={onCardClick}
            isDragging={isDragging}
            getColorSet={getColorSet}
            isCompletedView={isCompletedView}
            onNavigateByDay={index < 7 ? onNavigate : undefined}
            maxCards={4}
            compact
          />
        ))}
      </Grid>
      {hoveredCard && <HoverCard {...hoveredCard} isCompletedView={isCompletedView} />}
    </>
  );
};
